<template>
    <div class="fixed w-full h-full inset-0 bg-[#00000050] z-[10000]">
        <img src="/loader.gif"
            alt="" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
    </div>
</template>